module.exports = __webpack_public_path__ + "img/download-icon.3776349f.png";